module.exports = __webpack_public_path__ + "img/appAsset-brand--sunat.8fde5cd3.svg";